/**
 * Byline overlay positioning for meninger-debatt nodes
 * Fallback for browsers without CSS anchor positioning support (Firefox, Safari)
 */
(() => {
  const positionBylineOverlay = () => {
    const meningerDebattNode = document.querySelector('.node--full.meninger-debatt');
    if (!meningerDebattNode) return;

    // Check if browser supports anchor positioning
    if (CSS.supports('anchor-name', '--test')) return;

    const overlay = meningerDebattNode.querySelector('.byline-overlay');
    const picture = meningerDebattNode.querySelector('.main-illustration-wrapper picture');

    if (!overlay || !picture) return;

    const updatePosition = () => {
      const pictureRect = picture.getBoundingClientRect();
      const parentRect = overlay.parentElement.getBoundingClientRect();

      // Calculate position from top of parent to bottom of picture
      const topPosition = pictureRect.bottom - parentRect.top;

      // Get computed margin values
      const styles = window.getComputedStyle(overlay);
      const currentMargin = parseInt(styles.marginLeft) || 10;

      overlay.style.top = `${topPosition - currentMargin}px`;
      overlay.style.bottom = 'auto';
      overlay.style.transform = 'translateY(-100%)';
    };

    updatePosition();

    // Update on window resize
    window.addEventListener('resize', updatePosition);

    // Update when caption expands/collapses
    const captionCheckbox = meningerDebattNode.querySelector('.caption-expandable');
    if (captionCheckbox) {
      captionCheckbox.addEventListener('change', updatePosition);
    }
  };

  // Run after DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionBylineOverlay);
  } else {
    positionBylineOverlay();
  }
})();
